import {
  useState, useEffect,
} from 'react';
// import moment from 'moment';
import telemetryActions from '@state/telemetry/actions';
import constants from '@state/telemetry/constants';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';

const options = {
  colors: ['#999140', '#E3B505', '#DF8328', '#05EB60', '#724E56', '#084C61', '#56A3A6', '#DD6A39'],
  plotOptions: {
    bar: {
      columnWidth: '80%',
      dataLabels: {
        position: 'top', // top, center, bottom
      },
    },
  },
  // legend: {
  //   show: true,
  //   showForSingleSeries: true,
  // },
  fill: {
    opacity: [0.85, 0.85, 1],
    gradient: {
      inverseColors: false,
      shade: 'light',
      type: 'vertical',
      opacityFrom: 0.85,
      opacityTo: 0.55,
      stops: [0, 100, 100, 100],
    },
  },
  yaxis: {
    show: true,
    showAlways: true,
    opposite: false,
    reversed: false,
    forceNiceScale: true,
    decimalsInFloat: 2,
    axisTicks: {
      show: true,
      borderType: 'solid',
      width: 10,
    },
    tooltip: {
      enabled: true,
      offsetX: -20,
    },
    axisBorder: {
      show: true,
      width: 1,
      height: '100%',
      offsetX: 0,
      offsetY: 0,
    },
    labels: {
      show: true,
      hideOverlappingLabels: false,
      trim: true,
      style: {
        fontSize: '12px',
        fontFamily: 'montserrat, sans-serif',
        fontWeight: 400,
      },
    },
  },
};

function useStateBateryChart() {

  const { t } = useTranslation();
  const graphInitialData = useSelector(({ telemetry }) => telemetry.graphBatteryBoxPlot);
  const loadingGraph = useSelector(({ telemetry }) => telemetry.loadingBatteryGraphBoxPLot);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [selectGraph, setSelectGraph] = useState(constants.BOX_CONSULT);
  const [datePicker, setDatePicker] = useState(moment(new Date(), 'YYYY/MM/DD'));
  const [datePickerWeek, setDatePickerWeek] = useState(moment(new Date()));
  const [firstTime, setFirstTime] = useState(false);
  const [attributeGraph, setAttributeGraph] = useState({
    graphData: [],
    dates: [],
    labels: [],
    typeGraph: 'boxPlot',
    categories: [],
  });
  const dateConsult = [];

  const handleSelectGraph = (e) => {

    setSelectGraph(e.target.value);
    if (e.target.value === constants.BOX_CONSULT) {

      dispatch(telemetryActions.setTypeConsultBatteryBoxPlot(constants.BOX_CONSULT));

    } else {

      dispatch(telemetryActions.setTypeConsultBatteryBoxPlot(constants.HISTOGRAM_CONSULT));

    }

  };

  const changeDate = (e) => {

    setDatePicker(moment(datePicker, 'YYYY-MM-DD').add(e, 'days'));

  };

  const rangeDate = () => {

    const consultAttribute = {
      dateConsult: [
        moment(moment(datePicker).format('YYYY-MM-DD 00:00:00')).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
        moment(moment(datePicker).format('YYYY-MM-DD 23:59:59')).utcOffset('+00:00').format('YYYY-MM-DD HH:mm:ss'),
      ],
    };

    return consultAttribute;

  };

  useEffect(() => {

    if (firstTime) {

      setAttributeGraph(graphInitialData);
      dispatch(telemetryActions.setLoadingGraphBatteryBoxPlot(false));

    }
    setFirstTime(true);

  }, [graphInitialData, dispatch]);

  useEffect(() => {

    setLoading(loadingGraph);

  }, [loadingGraph]);

  useEffect(() => {

    if (firstTime) {

      const consultAttribute = rangeDate();

      dispatch(telemetryActions.setConsultAttributeBattery(consultAttribute));

    }
    setFirstTime(true);

  }, [datePicker, dispatch]);

  useEffect(() => {

    const currentDate2 = moment(datePickerWeek);
    const weekStart = currentDate2.clone().startOf('week');
    const weekEnd = currentDate2.clone().endOf('week');

    console.log('WEEK INI: ', moment(weekStart).format('YYYY-MM-DD 00:00:00'));
    console.log('WEEK END: ', moment(weekEnd).format('YYYY-MM-DD 23:59:59'));
    dateConsult.push(moment(weekStart).format('YYYY-MM-DD 00:00:00'));
    dateConsult.push(moment(weekEnd).format('YYYY-MM-DD 23:59:59'));
    dispatch(telemetryActions.setConsultAttributeBatteryBoxPlot({ dateConsult }));

  }, [datePickerWeek]);

  const {
    graphData,
    categories,
    labels,
    typeGraph,
  } = attributeGraph;

  let categorySeries;
  let enableMarkers;
  let titleGraph;
  let infoGraph;
  let totalRegisters;
  let messageTotalRegisters;
  let timeRegisters;
  let heigthCard;

  if (typeGraph === 'bar') {

    categorySeries = [
      ['0-5%'],
      ['5-10%'],
      ['10-15%'],
      ['15-20%'],
      ['20-25%'],
      ['25-30%'],
      ['30-35%'],
      ['35-40%'],
      ['40-45%'],
      ['45-50%'],
      ['50-55%'],
      ['55-60%'],
      ['60-65%'],
      ['65-70%'],
      ['70-75%'],
      ['75-80%'],
      ['80-85%'],
      ['85-90%'],
      ['90-95%'],
      ['95-100%'],
    ];
    // categorySeries = categorySeries.reverse();
    enableMarkers = true;
    titleGraph = t('views.device_graphics.boxplot.title_DOD');
    infoGraph = t('views.device_graphics.boxplot.HistogramLabelInfo');
    totalRegisters = 0;
    for (let i = 0; i < graphData.length; i += 1) {

      totalRegisters += graphData[i];

    }
    messageTotalRegisters = `${t('views.device_graphics.boxplot.HistogramLabelInfoTotal')} ${totalRegisters.toString()}`;
    timeRegisters = `${t('views.device_graphics.boxplot.HistogramLabelInfoRegisters')} ${(1440 / totalRegisters).toFixed(1)} min`;
    heigthCard = 565;

  } else {

    categorySeries = categories;
    enableMarkers = false;
    titleGraph = t('views.device_graphics.boxplot.title_Boxplot');
    infoGraph = t('views.device_graphics.boxplot.BoxplotLabelInfo');
    heigthCard = 400;

  }

  const series = [{
    name: labels[0],
    type: typeGraph,
    data: graphData,
  }];

  const optionsGraph = {
    chart: {
      height: 350,
      type: typeGraph,
      stacked: false,
      toolbar: {
        show: true,
        offsetX: 0,
        offsetY: 0,
        // tools: {
        //   download: true,
        //   selection: false,
        //   zoom: false,
        //   zoomin: false,
        //   zoomout: false,
        //   pan: true,
        // },
        export: {
          csv: {
            filename: 'Histogram-data',
            columnDelimiter: ',',
          },
          svg: {
            filename: undefined,
          },
          png: {
            filename: undefined,
          },
        },
      },
    },
    title: {
      text: titleGraph,
      align: 'left',
    },
    ...options,
    dataLabels: {
      enabled: enableMarkers,
      formatter(val) {

        return `${val}`;

      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#304758'],
      },
    },
    xaxis: {
      type: 'category',
      labels: {
        rotate: -45,
      },
      categories: categorySeries,
    },
    tooltip: {
      enabled: true,
      enabledOnSeries: [0],
      shared: true,
      intersect: false,
      fixed: {
        enabled: false,
        position: 'topLeft',
        offsetY: -70,
      },
      followCursor: true,
      fillSeriesColor: false,
      theme: 'dark',
      style: {
        fontSize: '12px',
        fontFamily: undefined,
      },
      onDatasetHover: {
        highlightDataSeries: true,
      },
      y: {
        formatter(value) {

          if (typeof value !== 'undefined') {

            return value.toFixed(2);

          }
          return value;

        },
      },
      items: {
        display: 'flex',
      },
      marker: {
        show: true,
      },
    },
  };

  return {
    loading,
    optionsGraph,
    series,
    typeGraph,
    selectGraph,
    handleSelectGraph,
    constants,
    changeDate,
    datePicker,
    datePickerWeek,
    setDatePicker,
    setDatePickerWeek,
    infoGraph,
    messageTotalRegisters,
    timeRegisters,
    heigthCard,
  };

}

export default useStateBateryChart;
